import Vue from 'vue';
import Router from 'vue-router';


import NProgress from 'nprogress';

const load = (path) => { // 路由懒加载
  return () => Promise.resolve(require(`@/views/${path}`).default)
}
const $import = (path) => { // 直接加载
  return () => import(`@/views/${path}`)
}
const Home=load('Home.vue');
const ErrorPage =load('404/ErrorPage.vue');
const NetworkFreight =load('product/NetworkFreight.vue');
const Logistics =load('product/Logistics.vue');
const AboutUs =load('public/AboutUs.vue');
const Customers =load('public/Customers.vue');
const Recruitment =load('public/Recruitment.vue');
const IntelligentWarehousing =load('product/IntelligentWarehousing.vue');
Vue.use(Router);
let constRouters = [
  {
    path: '/',
    hidden: true,
    redirect: {
      name: 'Home'
    }
  },
  {
    path: '/home',
    name: "Home",
    component: Home,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/network-freight',
    name: "NetworkFreight",
    component: NetworkFreight,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/logistics',
    name: "logistics",
    component: Logistics,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/intelligent-warehousing',
    name: "IntelligentWarehousing",
    component: IntelligentWarehousing,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/about-us',
    name: "AboutUs",
    component: AboutUs,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/recruitment',
    name: "Recruitment",
    component: Recruitment,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/customers',
    name: "Customers",
    component: Customers,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },
  {
    path: '/404',
    name: "404",
    component: ErrorPage,
    hidden: true,
    meta: {
      requireAuth: false
    }
  },

];

export let permissonRoutes = [
  { path: '*', redirect: '/404' }

];

const router = new Router({
    routes: constRouters,
    scrollBehavior () {
      return { x: 0, y: 0 }
    }
});
router.addRoutes(permissonRoutes);

router.afterEach((to, from) => {
    setTimeout(() => {
        let el = document.querySelector('.el-main')
      if (el){
        el.scrollTo(0,0);
      }
    }, 50);
    //
    NProgress.done();
});

// 解决Loading chunk (\d)+ failed问题
router.onError((error) => {
    const pattern = /Loading chunk/g
    const isChunkLoadFailed = error.message.match(pattern)
    const targetPath = (router as any).history.pending.fullPath
    if (isChunkLoadFailed && error.type === 'missing') {
        router.push(targetPath)
    }
})
export default router;



// WEBPACK FOOTER //
// ./src/router/index.ts